import { apiSlice } from "./apiSlice";

export const ReviewSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        reviewProductlist: builder.mutation({
            query: (data) => ({
                url: 'review/products?' + data,
                method: 'GET',
                credentials: "include",
            }),
        }),
        replyReview: builder.mutation({
            query: (data) => ({
                url: 'review/reply',
                method: 'POST',
                credentials: "include",
                body: data
            }),
        }),
        ProductReviewDetails: builder.mutation({
            query: (data) => ({
                method: "GET",
                url: 'review?' + data,
                credentials: "include",
            }),

            
        }),
       productReviewsList: builder.query({
            query: (data) => ({
                method: "GET",
                url: 'review?' + data,
                credentials: "include",
            })
        }),

        updateReview: builder.mutation({
            query: (data) => ({
                url: `/review`,
                method: 'POST',
                body: data,
            }),
         
        }),
    }),
});

export const {
    useReviewProductlistMutation,
    useProductReviewDetailsMutation,
    useReplyReviewMutation,
    useUpdateReviewMutation,
    useProductReviewsListQuery
} = ReviewSlice;
